export type SeriesTransform = {
  name: string;
  data: number[];
};

export type AverageAndDeviation = {
  average: SeriesTransform[];
  deviation: SeriesTransform[];
};

export const initialAverageAndDeviation: AverageAndDeviation = {
  average: [] as SeriesTransform[],
  deviation: [] as SeriesTransform[],
};
